import { render, staticRenderFns } from "./CardAddUserToLocker.vue?vue&type=template&id=c5570546&"
import script from "./CardAddUserToLocker.vue?vue&type=script&lang=js&"
export * from "./CardAddUserToLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports